class DarkMode {
  constructor() {
    this.isOn = false
    this.body = document.querySelector('body')
  }

  off() {
    this.body.classList.remove('dark-mode')
  }

  on() {
    this.body.classList.add('dark-mode')
  }

  toggle() {
    this.body.classList.toggle('dark-mode')
  }
}

export default DarkMode



// WEBPACK FOOTER //
// ./src/components/DarkMode.js